// src/i18n/en/users.js
const users = {
    name: 'User |||| Users',
    title: 'User Management',
    titles: {
        list: 'Users',
        create: 'Create User',
        edit: 'Edit User',
        show: 'User Details',
        change_password: 'Change Password',
        reset_password: 'Reset Password',
        user_information: 'User Information',
        role_assignment: 'Role',
        terminal_access: 'Terminal Access',
        new_user: 'New User',
        edit_user_prefix: 'Edit User:',
        current_assignment: 'Current Assignment',
        hmi_access: 'HMI Access',
    },
    fields: {
        id: 'ID',
        name: 'Full Name',
        full_name: 'Full Name',
        email: 'Email',
        role: 'Role',
        hotel: 'Hotel',
        hotelId: 'Assigned Hotel',
        hotelName: 'Hotel',
        group: 'Group',
        groupId: 'Assigned Group',
        groupName: 'Group',
        isActive: 'Active',
        lastLogin: 'Last login',
        createdAt: 'Created',
        updatedAt: 'Updated',
        password: 'Password',
        confirmPassword: 'Confirm password',
        role_assignment: 'Role & Assignment',
        staff_id: 'Staff ID',
        pin_configured: 'PIN Configured',
        pin_not_configured: 'PIN Not Configured',
        new_pin: 'New 4-digit PIN',
        assigned_hotel: 'Assigned Hotel',
        assigned_group: 'Assigned Group',
        staff_id_prefix: 'Staff ID:',
    },
    roles: {
        SuperAdmin: 'Super Administrator',
        superadmin: 'Super Admin',
        GroupAdmin: 'Group Administrator',
        groupadmin: 'Group Admin',
        HotelAdmin: 'Hotel Administrator',
        hoteladmin: 'Hotel Admin',
        Receptionist: 'Receptionist',
        receptionist: 'Receptionist',
        Developer: 'Developer',
        developer: 'Developer',
        User: 'User',
        user: 'User',
        super_admin: 'Super Administrator',
        group_admin: 'Group Administrator',
        hotel_admin: 'Hotel Administrator',
        // Roles for SelectInput choices
        'Super Admin': 'Super Admin',
        'Group Admin': 'Group Admin',
        'Hotel Admin': 'Hotel Admin',
    },
    labels: {
        hotel: 'Hotel',
        group: 'Group',
        no_hotel: 'No hotel assigned',
        no_group: 'No group assigned',
    },
    filters: {
        search: 'Search by name or email...',
        search_placeholder: 'Search users...',
        role: 'Role',
        all_roles: 'All roles',
        active: 'Only active',
        inactive: 'Only inactive',
        hotel: 'Hotel',
        all_hotels: 'All hotels',
        group: 'Group',
        all_groups: 'All groups',
    },
    actions: {
        create: 'Create User',
        edit: 'Edit',
        delete: 'Delete',
        activate: 'Activate',
        deactivate: 'Deactivate',
        change_password: 'Change password',
        reset_password: 'Reset password',
        assign_hotel: 'Assign hotel',
        assign_group: 'Assign group',
        view_activity: 'View activity',
        send_invitation: 'Send invitation',
        more: 'More actions',
        reset_pin: 'Reset PIN',
        save_pin: 'Save PIN',
        cancel: 'Cancel',
    },
    password_requirements: {
        minLength: 'At least 8 characters',
        hasUpper: 'An uppercase letter',
        hasLower: 'A lowercase letter',
        hasNumber: 'A number',
    },
    errors: {
        passwords_do_not_match: 'Passwords do not match',
        password_requirements_not_met: 'Password does not meet security requirements',
        password_change_failed: 'Failed to change password',
        delete_failed: 'Failed to delete user',
    },
    messages: {
        no_users: 'No users found',
        loading: 'Loading users...',
        create_success: 'User created successfully',
        create_success_alt: 'User created successfully',
        update_success: 'User updated successfully',
        delete_success: 'User deleted successfully',
        delete_confirm: 'Are you sure you want to delete this user?',
        activate_success: 'User activated successfully',
        deactivate_success: 'User deactivated successfully',
        password_changed: 'Password changed successfully',
        password_reset: 'Password reset email has been sent',
        invitation_sent: 'Invitation sent successfully',
        email_exists: 'A user with this email already exists',
        invalid_role: 'Invalid role for this user',
        cannot_delete_self: 'You cannot delete your own user',
        cannot_deactivate_self: 'You cannot deactivate your own user',
        access_denied: 'Access Denied',
        pin_reset_success: 'PIN reset successfully',
        pin_reset_error: 'Error resetting PIN',
        pin_length_error: 'PIN must be 4 digits',
        login_format: 'Login format:',
    },
    validation: {
        name_required: 'Name is required and must be at least 2 characters',
        name_min_length: 'Name must be at least 2 characters',
        email_required: 'Email is required',
        email_format: 'Please enter a valid email',
        password_required: 'Password is required and must be at least 8 characters',
        password_min_length: 'Password must be at least 8 characters',
        password_mismatch: 'Passwords do not match',
        role_required: 'Role is required',
        hotel_required: 'A hotel must be assigned for this role.',
        group_required: 'A group must be assigned for this role.',
    },
    dialogs: {
        delete_title: 'Delete User',
        delete_message: 'Are you sure you want to delete user "{{name}}"?',
        delete_message_generic: 'Are you sure you want to delete this user?',
        delete_warning: 'This action cannot be undone.',
        deactivate_title: 'Deactivate User',
        deactivate_message: 'Are you sure you want to deactivate user "%{name}"?',
        activate_title: 'Activate User',
        activate_message: 'Are you sure you want to activate user "%{name}"?',
        password_title: 'Change Password',
        password_message: 'Enter the new password for the user',
        reset_pin_title: 'Reset PIN for {{name}}',
    },
    notifications: {
        pin_invalid_format: 'PIN must be 4 digits',
        pin_reset_success: 'PIN reset successfully',
        password_updated: 'Password updated successfully',
    },
    help: {
        title: 'Users',
        description: 'Manage users and their system access permissions.',
        feature_management: 'User account creation and management',
        feature_roles: 'Role assignment: SuperAdmin, Group Admin, Hotel Admin, Receptionist',
        feature_permissions: 'Permission control by role and hotel/group assignment',
        role_description: 'The role determines the user\'s permissions and access',
        hotel_assignment: 'Assign the user to a specific hotel',
        group_assignment: 'Assign the user to a group of hotels',
        password_requirements: 'Password must be at least 8 characters and include uppercase, lowercase, numbers and special characters',
        basic_user_data: 'Complete the basic user data',
        basic_new_user_data: 'Complete the basic data for the new user',
        role_selection: 'Select role',
        role_selection_detailed: 'Select the corresponding role',
        email_role_not_editable: 'Basic data. Email and role are not editable.',
        user_hotel_group: 'Hotel or group the user belongs to.',
        pin_setup: 'Set PIN code.',
    },
};

export default users;
